import $ from 'jquery';
import BaseFeature from '../../foundation/base/base';

const classes = {
	activeBackground: 't-page__background--active',
};

export default class Page extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.el = element;
		this.$el = $(this.el);
		this.backgroundContainer = this.dom.backgroundContainer;

		this.backgrounds = null;

		this.addSubscriptions();
	}

	addSubscriptions() {
		this.subscribe('/page/setBackground', ({ current } = {}) => {
			this.setBackground(current);
		});
		this.subscribe('/page/nextBackground', ({ current } = {}) => {
			this.nextBackground(current);
		});
		this.subscribe('/page/addBackgrounds', ({ backgrounds } = {}) => {
			this.addBackgrounds(backgrounds);
		});
	}

	addBackgrounds(backgrounds) {
		if (backgrounds.length) {
			for (let i = 0; i < backgrounds.length; i++) {
				const element = document.createElement('div');
				element.setAttribute('class', 't-page__background');
				element.setAttribute('data-js', 'page-background');
				element.setAttribute('style', backgrounds[i]);
				this.backgroundContainer.appendChild(element);
			}
			this.backgrounds = this.$el.find('[data-js="page-background"]');
		}
	}

	setBackground(current) {
		if (!current) {
			return;
		}
		for (let i = 0; i < this.backgrounds.length; i++) {
			if (this.backgrounds[i].classList.contains(classes.activeBackground)) {
				this.backgrounds[i].classList.remove(classes.activeBackground);
			}
		}
		this.backgrounds[current].classList.add(classes.activeBackground);
	}

	nextBackground(current) {
		if (!current) {
			return;
		}
		for (let i = 0; i < this.backgrounds.length; i++) {
			this.backgrounds[i].classList.remove(classes.activeBackground);
		}
		this.backgrounds[current].classList.add(classes.activeBackground);
	}
}
